'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var props = {
  name: {
    type: String,
    default: ""
  },
  size: {
    type: String,
    default: void 0
  },
  url: {
    type: [String, Array],
    default: void 0
  },
  loadDefaultIcons: {
    type: Boolean,
    default: true
  },
  onClick: Function
};

exports["default"] = props;
//# sourceMappingURL=props.js.map
